import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import auth from './auth'
import config from './config'
import production from './production'

export default (history) => combineReducers({
  router: connectRouter(history),
  auth,
  config,
  production
})
